module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Thin-b45173bdaeba4d08547f916e89f49e01.eot";